<template>
  <m-layout id="distance">
    <m-distance></m-distance>
  </m-layout>
</template>
<script>

import DistanceCheck from '@/components/booking/distance_check'
export default {
  components: {
    'm-distance': DistanceCheck
  },
  data () {
    return {};
  }
};
</script>
